import React, { useState, useRef, useEffect } from 'react'
import styled from 'styled-components'
import useOnClickOutside from 'use-onclickoutside'
import { blinker } from '../../../admin/src/components/SPGrid3/TopBar/blinker'
import { injectIntl } from 'react-intl'

const isHex = value => value.startsWith('#')

const DropDownWrapper = styled.div`
  position: relative;
  width: 100%;
`

const Wrapper = styled.div`
  @media ${p => p.theme.sm} {
    width: auto;
    margin: 0 25px 0 15px;
  }

  width: ${p => p.theme.height};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const IconWrapper = styled.div`
  margin-right: 15px;
  position: relative;
  // border-radius: 50%;
  cursor: pointer;

  &.clicked {
    animation: ${blinker} 0.6s;
  }

  &:hover {
    opacity: 0.7;
  }
`

const Icon = styled.em`
  @media ${p => p.theme.sm} {
    margin-top: 0;
    position: absolute;
    top: 10.5px;
    right: 7.5px;
    font-size: 20px;
  }

  margin-top: 4px;
  position: static;
  font-size: 24px;
  color: white;
`

Icon.defaultProps = {
  className: 'far fa-comment-alt-plus'
}

const Item = styled.li`
  display: flex;
  align-items: center;
  padding: 8px;
  cursor: pointer;
  border-bottom: ${p => p.border ? '2px solid #f1f1f1' : 'none'};
  transition: margin 300ms ease;
  user-select: none;

  &:hover {
    background-color: #f5f9ff;
    margin-left: 5px;
  }
`

const ItemIconWrapper = styled.div`
  width: 36px;
  min-width: 36px;
  height: 36px;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:18px;
  border-radius:50%;
  background-color: ${p => isHex(p.color) ? p.color + '4D' : p.theme.colors[p.color]};
  color: ${p => isHex(p.color) ? p.color : p.theme.colors.on[p.color]};
`

const ItemIcon = styled.em``

const TextWrapper = styled.div`
  margin-left: 16px;
`

const ItemHeader = styled.div`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
`

const ItemDesc = styled.div`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
`

const DropDown = styled.ul`
  @media ${p => p.theme.breakpoints.sm} {
    top: 19px;
    right: ${p => p.type === 'create' ? '-6px' : '-2px'};
  }

  position: absolute;
  top: ${p => p.type === 'create' ? '5px' : '7px'};
  right: ${p => p.type === 'create' ? '-47px' : '6px'};
  width: ${p => p.type === 'create' ? '260px' : '220px'};
  padding: 8px 8px;
  background-color: ${p => p.theme.colors.surface};
  border: 2px solid #f1f1f1;
  border-radius: 5px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04);
  z-index: 1;
  
  &::before {
    @media ${p => p.theme.breakpoints.sm} {
      right: 17px;
    }

    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    top: -12px;
    right: ${p => p.type === 'create' ? '64px' : '10px'};
    border-bottom: 12px solid #fff;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    z-index: 1;
  }

  &::after {
    @media ${p => p.theme.breakpoints.sm} {
      right: 15px;
    }

    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    top: -15px;
    right: ${p => p.type === 'create' ? '62px' : '8px'};
    border-bottom: 14px solid #f1f1f1;
    border-left: 14px solid transparent;
    border-right: 14px solid transparent;
  }
`

const More = styled.div`
display:flex;
&:after {
    content: ' ▾';
    display: block;
    padding-left:5px;
}
// margin-right:15px;
font-size:0.9rem;
cursor:pointer;
user-select: none;
white-space: nowrap;
`

const ConfirmOverlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`

const ConfirmModal = styled.div`
  padding: 10px 14px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);
`

const ConfirmHeader = styled.h3``

const ConfirmText = styled.p``

const ConfirmButtons = styled.div`
  padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #ddd;
`

const Cancel = styled.span`
  color: ${p => p.theme.colors.primary ? p.theme.colors.primary : '#404e67'};
  cursor: pointer;
`

const Confirm = styled.button`
  padding: 5px 8px;
  background-color: ${p => p.theme.colors.danger ? p.theme.colors.danger : '#404e67'};
  color: ${p => p.theme.colors.on.danger ? p.theme.colors.on.danger : '#f5f5f5'};
  border: ${p => p.theme.colors.border.danger ? `1px solid ${p.theme.colors.border.danger}` : 'none'};
  border-radius: 4px;
`

const MoreDropDown = injectIntl((props) => {

  const { numOfSelected, runActionButton, removeSelected, intl, dropDownLabel, actionButtons, permissions = [] } = props
  const [open, setOpen] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)

  const ref = useRef()

  const close = () => setOpen(false)

  useOnClickOutside(ref, close)

  const mountRef = useRef();

  useEffect(() => {
    if (mountRef.current) {

      // setOpenModal(false) // Commented out this since this method doesn't exist? - FS 21-11-05

    } else {
      mountRef.current = true;
    }
  }, [])

  return (
    <>
      <Wrapper>
        <IconWrapper className={open ? 'clicked' : ''} onClick={() => setOpen(!open)}>
          <More>{intl.formatMessage({ id: dropDownLabel ? dropDownLabel : 'More' })}</More>
        </IconWrapper>
        {open ?
          <DropDownWrapper ref={ref}>
            <DropDown type="create">
              {
                actionButtons.length > 0 && actionButtons.map(actionButton => (
                  <Item onClick={() => { setTimeout(() => { setOpen(false); runActionButton(actionButton.effects) }, 180) }}>
                    <ItemIconWrapper color={actionButton.color}>
                      <ItemIcon className={actionButton.icon} />
                    </ItemIconWrapper>
                    <TextWrapper>
                      <ItemHeader>{actionButton.label}</ItemHeader>
                      <ItemDesc>{actionButton.description}</ItemDesc>
                    </TextWrapper>
                  </Item>
                ))
              }
              {
                permissions.includes('admin') && (
                  <Item onClick={() => setModalOpen(true)}>
                    <ItemIconWrapper color="danger">
                      <ItemIcon className={"fal fa-trash"} />
                    </ItemIconWrapper>
                    <TextWrapper>
                      <ItemHeader>{intl.formatMessage({ id: 'Tickets.Remove' })}</ItemHeader>
                      <ItemDesc>{intl.formatMessage({ id: 'Tickets.RemoveSelected' })}</ItemDesc>
                    </TextWrapper>
                  </Item>
                )
              }

            </DropDown>
          </DropDownWrapper>
          : ''}
      </Wrapper>
      {
        modalOpen && (
          <ConfirmOverlay>
            <ConfirmModal>
              <ConfirmHeader>{intl.formatMessage({ id: 'Tickets.RemoveHeading' })}</ConfirmHeader>
              <ConfirmText><strong>{numOfSelected}</strong> {intl.formatMessage({ id: 'Tickets.RemoveDescription' })}</ConfirmText>
              <ConfirmButtons>
                <Cancel onClick={() => setModalOpen(false)}>{intl.formatMessage({ id: 'Cancel' })}</Cancel>
                <Confirm onClick={() => { setTimeout(() => { setModalOpen(false); setOpen(false); removeSelected() }, 180) }}>{intl.formatMessage({ id: 'Remove' })}</Confirm>
              </ConfirmButtons>
            </ConfirmModal>
          </ConfirmOverlay>
        )
      }
    </>
  )
})

export default MoreDropDown